/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMarine48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M43 35.5l-19-3s2-6.876 2-14.5c0-9.75-3.5-16-3.5-16S44 10.988 43 35.5z'
      />
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M19 39V2h-6l2 1.947-2 1.948h6'
      />
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M47 39.012H1v2c0 1.988 4.686 6 8 6h23.5c4.544 0 11.784-2.568 13.816-6.634L47 39.012zM15 15.012L14 33 3 35.012l12-20z'
      />
    </svg>
  );
}

export default SvgMarine48;
